
import React, { lazy, Suspense } from 'react';
import { createRoot } from 'react-dom/client';
import { IntlProvider } from 'react-intl';
import { BrowserRouter as Router } from 'react-router-dom';
import { App as CommerceApp, ConfigContextProvider, Portal } from '../../aem-core-components';
import { initSentry } from '../global/utils/logger';
import partialConfig from '../App/config';
import Global from '../App/Global';
import loadLocaleData, { locale, messages } from '../App/i18n';
import CartPage from '../cart';
//import AlternateInventory from '../global/modules/alternateInventory/AlternateInventory';
import { CapHeader } from '../cap';

//const CapHeader = lazy(() => import(/* webpackMode: "eager" */ '../cap'));
const App = props => {
    const {
        storeView,
        graphqlEndpoint,
        graphqlMethod = 'POST',
        headers = '{}'
    } = JSON.parse(
        document.querySelector('meta[name="store-config"]')?.content ||
        document.querySelector('div[name="store-config"]')?.getAttribute('content') ||
        '{}'
    );
    const { mountingPoints } = partialConfig;
    const config = {
        ...partialConfig,
        storeView,
        graphqlEndpoint,
        // Can be GET or POST. When selecting GET, this applies to cache-able GraphQL query requests only. Mutations
        // will always be executed as POST requests.
        graphqlMethod,
        headers
    };
    return (
        <IntlProvider locale={locale} messages={messages}>
            <ConfigContextProvider config={config}>
                <CommerceApp>
                    <Global />
                    <Portal selector={mountingPoints.cartPage}>
                        <CartPage />
                    </Portal>
                    {/* <Portal selector={config.mountingPoints.pdpAlternateInventory}>
                        <AlternateInventory />
                    </Portal> */}
                    <Portal selector={mountingPoints.capHeader}>
                        <CapHeader />
                    </Portal>
                </CommerceApp>
            </ConfigContextProvider>
        </IntlProvider>
    );
};

const renderDOM = async () => {
    const { locale, messages } = await loadLocaleData();
    const root = document.createElement('div');
    document.body.appendChild(root);
    const isDevelopment = process.env.NODE_ENV === 'development';
    if (!isDevelopment) {
        initSentry();
    }
    const rootContainer = createRoot(root);
    rootContainer.render(
        <Router>
            <App locale={locale} messages={messages} />
        </Router>
    );
};

document?.addEventListener('readystatechange', () => {
    if (document?.readyState === 'complete') {
        renderDOM();
    }
});

export default App;
